<template>
	<el-card id='userAccount_s'  :style='returnStyle()'>
		<el-row  v-if='(userList.cash&&userList.cash.length) || (userList.bank&&userList.bank.length)'>
			<el-col :span='userList.cash&&userList.cash.length?12:24' class='bankStyle' v-if='userList.bank&&userList.bank.length'>
				<div class='container_s'>
					<div class='container_title'>
						 <span class='userTitle'>所有银行账户</span>
						 <el-checkbox :indeterminate="isIndeterminate_b" v-model="checkAllBank" @change="handleCheckAllChange_l"></el-checkbox>
					</div>
					
					<el-checkbox-group v-model="bankUserList" @change="handleCheckedCitiesChange_l">
					    <el-checkbox v-for="item in userList.bank" :label="item.id" :key="item.id" class='box_item'>{{item.name}}</el-checkbox>
					</el-checkbox-group>
				</div>
			</el-col>
			<el-col :span='userList.bank&&userList.bank.length?12:24' v-if='userList.cash&&userList.cash.length'>
				<div  class='container_s'>
					<div class='container_title'>
						<span class='userTitle'>所有现金账户</span>
						<el-checkbox :indeterminate="isIndeterminate_c" v-model="checkAllCash" @change="handleCheckAllChange_r" ></el-checkbox>
					</div>
					 
				  <el-checkbox-group v-model="cashUserList" @change="handleCheckedCitiesChange_r">
				    <el-checkbox v-for="item in userList.cash" :label="item.id" :key="item.id" class='box_item' >{{item.name}}</el-checkbox>
				  </el-checkbox-group>
				</div>
				
			</el-col>
		</el-row>
		<div class='noUserAccount' v-else>
			检测到当前无账户,点击
			<el-button type='text' @click='jumpNewAddAcount'>新增账户</el-button>
		</div>
	</el-card>
</template>
<script>
	export default {
		data() {
			return {
				userList:{},      // 账户列表
				bankUserList:[],  // 银行用户集合
				cashUserList:[],      // 现金用户集合
				 checkAllBank:false,   // 全选银行
				 checkAllCash:false,   // 全选现金
				 isIndeterminate_b:false,   // 全选状态银行 true 不确定  false  未选中
				 isIndeterminate_c:false   // 全选状态现金 true 不确定  false  未选中
			}
		},
		created() {
			this.getUserInfo();
		},
		mounted() {

		},
		methods:{
			//  跳转新增账户
			jumpNewAddAcount() {
				this.$router.push('./cashieraccount');
			},
			// 返回宽度
			returnStyle() {
				let towDivStyle = {width:"5.56rem"};
				let singleDivStyle = {width:"2.75rem"};
				if(this.userList.cash&&this.userList.cash.length&&this.userList.bank&&this.userList.bank.length) {
					return towDivStyle;
				}else {
					return singleDivStyle;
				}
			},
			 // 获取所有账户
	        getUserInfo() {
	          this.$http.post('journal/findAccount',{type:'3'}).then(res=>{
	              if(res&&res.data.code==1) {
	                this.userList = res.data.data;
	                this.$emit('sendList',res.data.data);
	                if(this.userList.bank.length) {

	                }
	                if(this.userList.cash.length) {

	                }
	               
	              }
	          })
	        },
	        // 银行选择 
	               // 全选变化
	        handleCheckAllChange_l(val) {
	        	
	        	if(val) {
		        	this.userList.bank.forEach(i=>{
		        		this.bankUserList.push(i.id)
		        	})
	        	}else {
	        		this.bankUserList = [];
	        	}
        		this.isIndeterminate_b = false;
        		this.$emit('arrayChangeSend',{bankUserList:this.bankUserList,cashUserList:this.cashUserList})
	        }, 
	              // 单选变化
	        handleCheckedCitiesChange_l(value) {
	        	let checkedCount = value.length;
		        this.checkAllBank = checkedCount === this.userList.bank.length;
		        this.isIndeterminate_b = checkedCount > 0 && checkedCount < this.userList.bank.length;
		        this.$emit('arrayChangeSend',{bankUserList:this.bankUserList,cashUserList:this.cashUserList})
	        },

	        // 现金选择
	             // 全选变化
	        handleCheckAllChange_r(val) {
	        	if(val) {
		        	this.userList.cash.forEach(i=>{
		        		this.cashUserList.push(i.id)
		        	})
	        	}else {
	        		this.cashUserList = [];
	        	}
        		this.isIndeterminate_c = false;
        		this.$emit('arrayChangeSend',{bankUserList:this.bankUserList,cashUserList:this.cashUserList})
	        },
	               // 单选变化
	        handleCheckedCitiesChange_r(value) {
	        	let checkedCount = value.length;
		        this.checkAllCash = checkedCount === this.userList.cash.length;
		        this.isIndeterminate_c = checkedCount > 0 && checkedCount < this.userList.cash.length;
		        this.$emit('arrayChangeSend',{bankUserList:this.bankUserList,cashUserList:this.cashUserList})
	        }
		}
	}
</script>
<style lang=less>
	#userAccount_s {
		position: absolute;
		z-index:9999;
		min-width: 180px;
		.noUserAccount {
			height: 100px;
			text-align: center;
			line-height: 100px;
			color: #999;
		}
		.el-card__body {
			padding: 0;
			box-sizing: border-box;
		}
		.container_s {
			padding: 20px;
			.container_title {
				padding-bottom: 20px;
				border-bottom: 1px solid #EDEDED;
			}
		}
		.box_item {
			display: block;
			margin-top: 20px;
		}
		.userTitle {
			margin-right: 1.15rem;
		}
		.bankStyle {
			border-right: 1px solid #EDEDED;
		}


		/*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
			background: #108EE9;
   			border-color: #108EE9;
		}
		.el-checkbox__input.is-checked + .el-checkbox__label {
			color: #108EE9;
		}*/
	}
</style>


// WEBPACK FOOTER //
// src/pages/cashier/components/userAccount.vue